// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tasks_tasksSection__AqbTK {
  width: 100%;
}

.Tasks_taskCategory__YYVP8 {
  margin-bottom: 24px;
}

.Tasks_categoryHeader__W8yrk {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.Tasks_categoryHeader__W8yrk h2 {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}

.Tasks_comingSoon__3z99U {
  font-size: 12px;
  color: #666;
  padding: 4px 8px;
  background: #1a1a1a;
}

.Tasks_tasksList__ct1IQ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Tasks_taskCard__ngh6r {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #2a2a2a;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Tasks_taskCard__ngh6r:hover:not(.Tasks_disabled__cSQ0u) {
  background: #333333;
}

.Tasks_taskIcon__pl23P {
  width: 40px;
  height: 40px;
  background: #1a1a1a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 16px;
}

.Tasks_taskInfo__Bz5cj {
  flex: 1 1;
}

.Tasks_taskInfo__Bz5cj h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.Tasks_taskPoints__sG4wM {
  margin: 4px 0 0;
  color: #4CAF50;
  font-size: 14px;
}

.Tasks_taskStatus__a5AZk {
  margin-left: 16px;
}

.Tasks_claimButton__WMBTn {
  padding: 8px 24px;
  background: #ffffff;
  color: #000000;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.Tasks_claimButton__WMBTn:hover:not(:disabled) {
  opacity: 0.9;
}

.Tasks_completedBadge__pYqa\\+ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #ABFF00;
  color: #000000;
  border-radius: 50%;
  font-size: 14px;
}

.Tasks_taskCard__ngh6r.Tasks_completed__ZOMW3 {
  cursor: default;
}

/* Disabled states */
.Tasks_taskCategory__YYVP8.Tasks_disabled__cSQ0u {
  opacity: 0.5;
}

.Tasks_taskCard__ngh6r.Tasks_disabled__cSQ0u {
  cursor: not-allowed;
  pointer-events: none;
}

.Tasks_claimButton__WMBTn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #666;
}

@media (max-width: 768px) {
  .Tasks_taskCard__ngh6r {
    padding: 16px;
  }
  
  .Tasks_taskIcon__pl23P {
    width: 32px;
    height: 32px;
    font-size: 16px;
    margin-right: 12px;
  }
  
  .Tasks_claimButton__WMBTn {
    padding: 6px 16px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/DashboardPage/Tasks/Tasks.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".tasksSection {\n  width: 100%;\n}\n\n.taskCategory {\n  margin-bottom: 24px;\n}\n\n.categoryHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.categoryHeader h2 {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.comingSoon {\n  font-size: 12px;\n  color: #666;\n  padding: 4px 8px;\n  background: #1a1a1a;\n}\n\n.tasksList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.taskCard {\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  background: #2a2a2a;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.taskCard:hover:not(.disabled) {\n  background: #333333;\n}\n\n.taskIcon {\n  width: 40px;\n  height: 40px;\n  background: #1a1a1a;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  margin-right: 16px;\n}\n\n.taskInfo {\n  flex: 1;\n}\n\n.taskInfo h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.taskPoints {\n  margin: 4px 0 0;\n  color: #4CAF50;\n  font-size: 14px;\n}\n\n.taskStatus {\n  margin-left: 16px;\n}\n\n.claimButton {\n  padding: 8px 24px;\n  background: #ffffff;\n  color: #000000;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.claimButton:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.completedBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #ABFF00;\n  color: #000000;\n  border-radius: 50%;\n  font-size: 14px;\n}\n\n.taskCard.completed {\n  cursor: default;\n}\n\n/* Disabled states */\n.taskCategory.disabled {\n  opacity: 0.5;\n}\n\n.taskCard.disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.claimButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #666;\n}\n\n@media (max-width: 768px) {\n  .taskCard {\n    padding: 16px;\n  }\n  \n  .taskIcon {\n    width: 32px;\n    height: 32px;\n    font-size: 16px;\n    margin-right: 12px;\n  }\n  \n  .claimButton {\n    padding: 6px 16px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tasksSection": `Tasks_tasksSection__AqbTK`,
	"taskCategory": `Tasks_taskCategory__YYVP8`,
	"categoryHeader": `Tasks_categoryHeader__W8yrk`,
	"comingSoon": `Tasks_comingSoon__3z99U`,
	"tasksList": `Tasks_tasksList__ct1IQ`,
	"taskCard": `Tasks_taskCard__ngh6r`,
	"disabled": `Tasks_disabled__cSQ0u`,
	"taskIcon": `Tasks_taskIcon__pl23P`,
	"taskInfo": `Tasks_taskInfo__Bz5cj`,
	"taskPoints": `Tasks_taskPoints__sG4wM`,
	"taskStatus": `Tasks_taskStatus__a5AZk`,
	"claimButton": `Tasks_claimButton__WMBTn`,
	"completedBadge": `Tasks_completedBadge__pYqa+`,
	"completed": `Tasks_completed__ZOMW3`
};
export default ___CSS_LOADER_EXPORT___;
